// schema.js
import * as yup from 'yup'

// ZIP code pattern (generic format)
const zipCodePattern = /^[a-zA-Z0-9\s-]{3,10}$/

export const paymentSchema = yup.object().shape({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    address1: yup.string().required('Address1 is required'),
    address2: yup.string(),
    city: yup.string()
        .required('City is required')
        .matches(/^[a-zA-Z\s-]+$/, 'City can only contain letters, spaces, and hyphens'),
    state: yup.string()
        .required('State/Province is required')
        .matches(/^[a-zA-Z\s-]+$/, 'State/Province can only contain letters, spaces, and hyphens')
        .min(2, 'State/Province must be at least 2 characters')
        .max(50, 'State/Province must be less than 50 characters'),
    zip: yup.string()
        .required('ZIP/Postal code is required')
        .matches(zipCodePattern, 'Please enter a valid ZIP/Postal code'),
    country: yup.string().required('Country is required'),
    company: yup.string(),
    phone: yup.string().required('Phone is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    amount: yup.number().typeError('Amount must be a number').positive('Amount must be positive').required('Amount is required'),
})
